module.exports = __webpack_public_path__ + "img/download-mf-warning.0f22d4aa.png";